<template>
    <b-form-group
            :label="label"
            :label-for="id"
            :class="{
            'label-sm': labelSize === 'sm',
            'label-md': labelSize === 'md',
            'label-lg': labelSize === 'lg',
        }"
            class="ms-date-picker"
    >
        <b-input-group class="ms-date-picker-group">
            <b-input-group-prepend data-toggle>
                <b-input-group-text>
                    <a class="input-button">
                        <i class="far fa-calendar-day" />
                    </a>
                </b-input-group-text>
            </b-input-group-prepend>
            <flat-pickr
                    class="ms-date-picker-calendar form-control"
                    :name="name"
                    :config="mergedPickerConfig"
                    :disabled="disabled"
                    :value="value"
                    :placeholder="placeholder"
                    @input="handleInput"
            />
        </b-input-group>

        <input-error
                :errors="errors"
                :field="name"
        />
    </b-form-group>
</template>
<script>
    import './MsDatePicker.scss';
    import FlatPickr from 'vue-flatpickr-component';
    import {generateRandomString} from "./../../../helpers/stringHelpers";
    import InputError from "../../InputError/InputError";

    const DEFAULT_PICKER_CONFIG = {
        monthSelectorType: 'static',
        wrap: true,
        dateFormat: 'Y-m-d',
        altFormat: 'm/d/Y',
        altInput: true,
        enableTime: false,
        prevArrow: '<i class="far fa-chevron-left"></i>',
        nextArrow: '<i class="far fa-chevron-right"></i>',
    };
    export default {
        name: 'MsDatePicker',
        components: {
            InputError,
            FlatPickr,
        },
        props: {
            value: {
                type: [
                    String,
                    Date
                ],
            },
            label: {
                type: String,
                required: false,
                default: '',
            },
            id: {
                type: String,
                default: () => {
                    return generateRandomString(10);
                }
            },
            placeholder: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: 'date'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            pickerConfig: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            errors: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            labelSize: {
                type: String,
                required: false,
                default: 'sm',
                validator: (value) => {
                    return [
                        'sm',
                        'md',
                        'lg'
                    ].indexOf(value) > -1;
                }
            },
        },
        data() {
            return {
                mergedPickerConfig: {
                    ...DEFAULT_PICKER_CONFIG,
                    ...this.pickerConfig
                }
            };
        },
        methods: {
            handleInput(value) {
                this.$emit('input', value);
            }
        }
    };
</script>
